import React, { useState, useEffect, useRef } from 'react';
import './header.css';

const slideImages = [
  'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=1920&q=85',
  'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=1920&q=85',
  'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1920&q=85',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=1920&q=85',
];

function Header() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevIndex) => (prevIndex + 1) % slideImages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  // Touch handlers for mobile swipe
  const handleTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    const distance = touchStartX.current - touchEndX.current;
    
    // Swipe Left -> Next slide
    if (distance > 50) {
      setCurrentSlide((prev) => (prev + 1) % slideImages.length);
    }
    // Swipe Right -> Previous slide
    if (distance < -50) {
      setCurrentSlide((prev) => (prev === 0 ? slideImages.length - 1 : prev - 1));
    }

    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  return (
    <header
      className="hero-section"
      id="home"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* Background Slides */}
      <div className="hero-slides-wrapper">
        {slideImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>

      {/* Dark Vignette Overlay */}
      <div className="hero-gradient"></div>

      {/* Main Content */}
      <div className="hero-content">
        <div className="hero-badge">
          <span className="hero-badge-dot"></span>
          <span>TALENT & CREATIVE PORTFOLIO</span>
        </div>

        <h1 className="hero-title">
          DISCOVER THE FACES.

.<br />
          <span className="hero-title-highlight">DEFINING THE VISUALS.</span>
        </h1>

        <p className="hero-subtitle">
         A curated portfolio of top fashion models and editorial photoshoots crafted for brands, agencies, and creative visionaries.
        </p>

        {/* Action Buttons */}
        <div className="hero-cta-group">
          <a href="/model-photos" className="btn-hero btn-hero-primary">
            EXPLORE MODELS
          </a>
          <a href="/fashion-photos" className="btn-hero btn-hero-outline">
           VIEW PHOTOSHOOTS
          </a>
        </div>

        {/* Feature Highlights */}
        <div className="hero-stats">
          <div className="hero-stat-item">
            <span className="stat-number">250+</span>
            <span className="stat-label">Models</span>
          </div>
          <div className="stat-divider"></div>
          <div className="hero-stat-item">
            <span className="stat-number">1.2K+</span>
            <span className="stat-label">Shoots</span>
          </div>
          <div className="stat-divider"></div>
          <div className="hero-stat-item">
            <span className="stat-number">4K</span>
            <span className="stat-label">Production</span>
          </div>
        </div>

        {/* Slide Pagination Dots */}
        <div className="hero-dots">
          {slideImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </header>
  );
}

export default Header;